import React from "react";

import { ItemJobStatus } from "../../../util/enums";
import StyledBadge from "../StyledBadge";

type Props = {
  value?: string;
  backgroundColor?: string;
  dataCy?: string;
  textColor?: string;
  classes?: any;
  className?: string;
};

const BadgeItemJobStatus = (props: Props) => {
  const { value, className, dataCy } = props;

  const renderBadge = (backgroundColor: string, textColor: string, value?: string) => {
    if (value)
      return (
        <StyledBadge
          dataCy={dataCy}
          backgroundColor={backgroundColor}
          textColor={textColor}
          value={value}
          className={className}
        />
      );

    return <> </>;
  };

  switch (value) {
    case ItemJobStatus.DELIVERED:
      return renderBadge("#D1E9FF", "#1570EF", value);
    case ItemJobStatus.REGISTERED:
      return renderBadge("#EBE9FE", "#6938EF", value);
    case ItemJobStatus.LOADED:
      return renderBadge("#D6F4F2", "#38CFC4", value);
    case ItemJobStatus.TRANSSHIPPED:
      return renderBadge("#E0F2FE", "#0086C9", value);
    case ItemJobStatus.TAKEN:
      return renderBadge("#E0EAFF", "#444CE7", value);
    case ItemJobStatus.VOID:
      return renderBadge("#F2F4F7", "#475467", ItemJobStatus.VOIDED);
    case ItemJobStatus.DISPOSAL:
      return renderBadge("#FFEAD5", "#EC4A0A", value);
    case ItemJobStatus.MISSING:
      return renderBadge("#FEE4E2", "#D92D20", value);
    case ItemJobStatus.NOT_SIGHTED:
      return renderBadge("#FEE4E2", "#D92D20", value);
    case ItemJobStatus.SHIPPED:
      return renderBadge("#FEF0C7", "#DC6803", value);
    case ItemJobStatus.PACKED:
      return renderBadge("#F4EBFF", "#7F56D9", value);
    case ItemJobStatus.UPLIFTED:
      return renderBadge("#FFE4E8", "#E31B54", value);
    default:
      return renderBadge("#E0F2FE", "#0086C9", value);
  }
};

export default BadgeItemJobStatus;
